export default __webpack_public_path__ + "static/media/facebook-messenger.75fd8907.svg";